import React, { useEffect, useState } from "react";
import axios from "axios";
import PaginatedTable from "../components/library/Pagination";
import API_BASE_URL from "../config/api";

const MasterScreen = () => {
  const [parents, setParents] = useState([]);
  const [selectedParent, setSelectedParent] = useState("");
  const [children, setChildren] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [selectedParentTitle, setSelectedParentTitle] = useState("");
  const [notification, setNotification] = useState(null);
  const [newMaster, setNewMaster] = useState({
    title: "",
    value: "",
    mainId: null,
    parentId: null,
    isActive: true,
  });

  useEffect(() => {
    fetchParents();
  }, []);

  const fetchParents = async () => {
    const res = await axios.get(`${API_BASE_URL}/api/Config/parents`);
    setParents(res.data);
  };

  const fetchChildren = async (parentId) => {
    const res = await axios.get(`${API_BASE_URL}/api/Config/children/${parentId}`);
    setChildren(res.data);
  };

  const handleParentChange = (e) => {
    const value = e.target.value;
    const title = e.target.options[e.target.selectedIndex].text;

    setSelectedParent(value);
    setSelectedParentTitle(title);
    if (value) {
      fetchChildren(value);
    } else {
      setChildren([]);
    }
  };

  const openEditModal = (child) => {
    setEditData(child);
    setIsModalOpen("edit");
  };

  const handleSave = async () => {
    await axios.put(`${API_BASE_URL}/api/Config/${editData.id}`, editData);
    fetchChildren(selectedParent);
    setIsModalOpen(null);
  };

  const handleAdd = async () => {
    try {
      const res = await axios.post(`${API_BASE_URL}/api/Config/AddGeneralMaster`, newMaster);
      setNotification({ type: "success", message: "Record added successfully" });

      if (selectedParent) {
        handleParentChange({
          target: {
            value: selectedParent,
            selectedIndex: parents.findIndex(p => p.id === Number(selectedParent)) + 1,
            options: [{}, ...parents.map(p => ({ text: p.title }))]
          }
        });
        setIsModalOpen(null);
      }
    } catch (err) {
      setNotification({ type: "error", message: err.message });
    }
  };

  const closeNotification = () => setNotification(null);

  return (
    <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
      <div className="layout-container flex h-full grow flex-col">
        <div className="flex flex-1 justify-center py-5">
          <div className="layout-content-container flex flex-col flex-1">
            <h1 className="text-3xl font-bold mb-6">Master Screen</h1>


            {/* {notification && (
        <div
          className={`mb-4 p-4 rounded ${notification.type === "error"
            ? "bg-red-100 text-red-700"
            : "bg-green-100 text-green-700"
            }`}
        >
          <div className="flex justify-between items-center">
            <span>{notification.message}</span>
            <button onClick={closeNotification} className="font-bold text-xl leading-none">
              ×
            </button>
          </div>
        </div>
      )} */}

            <div className="flex items-center justify-between mb-4">
              <select
                className="form-input max-w-[250px]"
                value={selectedParent}
                onChange={handleParentChange}
              >
                <option value="">-- Select --</option>
                {parents.map((p) => (
                  <option key={p.id} value={p.id}>{p.title}</option>
                ))}
              </select>
              {selectedParent && (
                <div className="my-4 flex justify-end">
                  <button
                    className="custom-btn"
                    onClick={() => {
                      setNewMaster({
                        title: "",
                        value: "",
                        mainId: selectedParent,
                        parentId: selectedParent,
                        isActive: true,
                      });
                      setIsModalOpen("add");
                    }}
                  >
                    + Add {selectedParentTitle}
                  </button>
                </div>
              )}
            </div>
            <div className="py-3">
              <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white">
                <PaginatedTable
                  columns={[
                    "Title",
                    "Value",
                    "Action",
                  ]}
                  data={children}
                  pageSize={10}
                  renderRow={(child, index) => (
                    <tr key={child.id} className={`border-t border-t-[#dde1e3] ${!child.isActive ? "bg-red-50 text-red-600" : ""
                      }`}>
                      <td className="h-[72px] px-4 py-2 text-sm font-normal leading-normal">
                        {child.title}
                      </td>
                      <td className="h-[72px] px-4 py-2 text-[#121516] text-sm font-normal leading-normal">
                        {child.value && child.value.trim() !== "" ? child.value : "-"}
                      </td>
                      <td className="h-[72px] px-4 py-2 text-[#6a7881] text-sm font-normal leading-normal">
                        <button
                          className="custom-btn"
                          onClick={() => openEditModal(child)}
                        >
                          Edit
                        </button>
                      </td>

                    </tr>
                  )}
                />

              </div>

            </div>
            {/* Edit Modal */}
            {isModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[9999]">
                <div className="bg-white p-6 rounded shadow-md w-[400px]">
                  <h3 className="text-lg font-bold mb-3">
                    {isModalOpen === "edit"
                      ? `Edit ${selectedParentTitle}`
                      : `Add ${selectedParentTitle}`}
                  </h3>

                  <input
                    type="text"
                    value={isModalOpen === "edit" ? editData.title : newMaster.title}
                    onChange={(e) =>
                      isModalOpen === "edit"
                        ? setEditData({ ...editData, title: e.target.value })
                        : setNewMaster({ ...newMaster, title: e.target.value })
                    }
                    placeholder="Title"
                    className="w-full border rounded p-2 mb-2"
                  />

                  <input
                    type="text"
                    value={isModalOpen === "edit" ? editData.value : newMaster.value}
                    onChange={(e) =>
                      isModalOpen === "edit"
                        ? setEditData({ ...editData, value: e.target.value })
                        : setNewMaster({ ...newMaster, value: e.target.value })
                    }
                    placeholder="Value"
                    className="w-full border rounded p-2 mb-2"
                  />

                  <label className="flex items-center gap-2 mb-3">
                    <input
                      type="checkbox"
                      checked={
                        isModalOpen === "edit"
                          ? editData.isActive
                          : newMaster.isActive
                      }
                      onChange={(e) =>
                        isModalOpen === "edit"
                          ? setEditData({ ...editData, isActive: e.target.checked })
                          : setNewMaster({ ...newMaster, isActive: e.target.checked })
                      }
                    />
                    Active
                  </label>

                  <div className="flex justify-end gap-2">
                    <button
                      className="cancel-btn"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn-black"
                      onClick={isModalOpen === "edit" ? handleSave : handleAdd}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterScreen;